// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
  border: 1px solid var(--app-mid-lighter-2);
  --border-radius: 5px;
  border-radius: 5px;
  padding: 0;
  --box-shadow: none;
}

.page .input-field-wrap .input-field, .page .input-fields-vModal_alarm.input-fields--text .input-field, .page .template_emails-push .input-email .input-field, .page .input-field-wrap .input-field-lg, .row .field-input .fi-input {
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --padding-start: 8px;
  --padding-end: 8px;
}

.page .input-field-wrap .input-field-lg, .row .field-input .fi-input {
  --padding-top: 12px;
  --padding-bottom: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
}

.pg-footer {
  border-top: 1px solid var(--app-mid-lighter-2);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.pg-footer .foot-btn {
  margin: 0;
  font-weight: 600;
}
.pg-footer .foot-btn.mw-120 {
  min-width: 120px;
}
.pg-footer::before {
  content: normal;
}

.pg-header {
  padding: 15px 20px;
  background-color: var(--app-main-darker);
}
.pg-header .head-elem.he-title {
  margin-bottom: 20px;
}
.pg-header .head-elem.he-title.mb-0 {
  margin-bottom: 0;
}
.p-20.pg-header {
  padding: 20px 20px;
}

.page .input-field-wrap.w-stacked-lbl .input-field-lbl, .page .input-lbl, .page .recap-grid .output-val, .page .recap-grid-type2 .output-val, .page .template_emails-push .emails .email .text, .alert-panel .panel-infos {
  word-break: break-all;
  word-break: break-word;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

/* 
aggiungere mixin per:
- elementi lista con + di una riga

prove da fare:
- dove uso @media, sia dentro che fuori puntare alle classi usando
  le variabili css (\$)
*/
.page-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.page-wrapper .page-wrap-scrollable {
  flex: 1;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
}
.page-wrapper .page-wrap-scrollable .page {
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
}

.page {
  padding: 20px 20px 50px;
  padding-top: 30px;
}
.page .btnbar {
  display: flex;
  justify-content: center;
}
.page .btnbar .el-btn {
  margin: 0;
  font-weight: 600;
}
.page .btnbar .el-btn.mw-180 {
  min-width: 180px;
}
.page .btnbar .el-btn:not(:last-child).mr-25 {
  margin-right: 25px;
}
.page .btnbar.mt-40 {
  margin-top: 40px;
}
.page .checkboxes {
  padding-top: 15px;
}
.page .checkboxes.pt-5 {
  padding-top: 5px;
}
.page .description {
  color: var(--app-mid-dark);
}
.page .description .b {
  font-weight: 600;
}
.page .description .b.uppercase {
  text-transform: uppercase;
}
.page .description.lh-13 {
  line-height: 1.3;
}
.page .description.mb-20 {
  margin-bottom: 20px;
}
.page .description.pt-10 {
  padding-top: 10px;
}
.page .images-cart {
  display: flex;
  justify-content: center;
}
.page .images-cart .img-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page .images-cart .img-panel .ip-num {
  margin-bottom: 5px;
  color: var(--app-main);
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}
.page .images-cart .img-panel .ip-img-wrap {
  flex: 1;
  border: 1px solid var(--app-mid-lighter-2);
}
.page .images-cart .img-panel .ip-img-wrap .ip-img {
  vertical-align: middle;
}
.page .images-cart .img-panel:not(:last-child) {
  padding-right: 30px;
}
.page .images-cart.mt-20 {
  margin-top: 20px;
}
.page .images-cart.mt-25 {
  margin-top: 25px;
}
.page .input-field-wrap {
  display: flex;
  align-items: center;
}
.page .input-field-wrap .input-field {
  max-width: 300px;
}
.page .input-field-wrap .input-field.ml-15 {
  margin-left: 15px;
}
.page .input-field-wrap .input-field.ml-20 {
  margin-left: 20px;
}
.page .input-field-wrap .input-field.mxv-250 {
  max-width: 250px;
}
.page .input-field-wrap .input-field.mxv-350 {
  max-width: 350px;
}
.page .input-field-wrap .input-field.mxv-400 {
  max-width: 400px;
}
.page .input-field-wrap .input-field.mxv250 {
  max-width: 250px;
}
.page .input-field-wrap .input-field.mxv350 {
  max-width: 350px;
}
.page .input-field-wrap .input-field.mxv400 {
  max-width: 400px;
}
.page .input-field-wrap .input-field.mxv-100p, .page .input-field-wrap .input-field.mxv100p {
  max-width: 100%;
}
.page .input-field-wrap .input-field-lg.fz-15 {
  font-size: 15px;
}
.page .input-field-wrap .input-field-lg.mxv-100p, .page .input-field-wrap .input-field-lg.mxv100p {
  max-width: 100%;
}
.page .input-field-wrap .input-field-lg.mxw-300 {
  max-width: 300px;
}
.page .input-field-wrap .input-field-lg.mxw-350 {
  max-width: 350px;
}
.page .input-field-wrap .input-field-lg.readonly {
  border: 0;
}
.page .input-field-wrap .input-help {
  margin-left: 12px;
  color: var(--app-main-softer);
  font-size: 22px;
}
.page .input-field-wrap .input-help.ml-15 {
  margin-left: 15px;
}
.page .input-field-wrap .input-help.ml-20 {
  margin-left: 20px;
}
.page .input-field-wrap .input-unit {
  margin-left: 12px;
  color: rgba(var(--app-mid-rgb), 0.7);
  font-size: 14px;
  font-weight: 500;
}
.page .input-field-wrap.w-stacked-lbl {
  flex-direction: column;
  align-items: flex-start;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl {
  color: var(--app-mid-dark);
  font-size: 14px;
  font-weight: 500;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-0 {
  margin-bottom: 0;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-5 {
  margin-bottom: 5px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-10 {
  margin-bottom: 10px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-15 {
  margin-bottom: 15px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-20 {
  margin-bottom: 20px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-25 {
  margin-bottom: 25px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-30 {
  margin-bottom: 30px;
}
.page .input-field-wrap.dg-v1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 250px));
  gap: 15px;
}
.page .input-field-wrap:not(:last-child) {
  margin-bottom: 20px;
}
.page .input-field-wrap.mb-0 {
  margin-bottom: 0;
}
.page .input-field-wrap.mb-5 {
  margin-bottom: 5px;
}
.page .input-field-wrap.mb-10 {
  margin-bottom: 10px;
}
.page .input-field-wrap.mb-15 {
  margin-bottom: 15px;
}
.page .input-field-wrap.mb-20 {
  margin-bottom: 20px;
}
.page .input-field-wrap.mb-25 {
  margin-bottom: 25px;
}
.page .input-field-wrap.mb-30 {
  margin-bottom: 30px;
}
.page .input-field-wrap.mxw-350 {
  max-width: 350px;
}
.page .input-fields-vModal_alarm {
  display: flex;
  flex-wrap: wrap;
}
.page .input-fields-vModal_alarm.input-fields--check {
  margin: -8px -10px 0;
}
.page .input-fields-vModal_alarm.input-fields--check .input-field.special {
  margin-left: 15px;
}
.page .input-fields-vModal_alarm.input-fields--text {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 250px));
  gap: 10px 30px;
}
.page .input-fields-vModal_alarm.input-fields--toggle {
  margin: -10px -20px 0;
}
.page .input-fields-vModal_alarm:not(:last-child) {
  margin-bottom: 20px;
}
.page .input-lbl {
  margin-bottom: 15px;
  color: var(--app-mid);
  font-size: 18px;
  font-weight: 500;
}
.page .input-lbl.input-lbl--mid-dark {
  color: var(--app-mid-dark);
}
.page .input-lbl.fz-14 {
  font-size: 14px;
}
.page .input-lbl.fz-15 {
  font-size: 15px;
}
.page .input-lbl.fz-16 {
  font-size: 16px;
}
.page .input-lbl.fz-17 {
  font-size: 17px;
}
.page .input-lbl.fz-19 {
  font-size: 19px;
}
.page .input-lbl.fz-20 {
  font-size: 20px;
}
.page .input-lbl.mb-0 {
  margin-bottom: 0;
}
.page .input-lbl.mb-5 {
  margin-bottom: 5px;
}
.page .input-lbl.mb-10 {
  margin-bottom: 10px;
}
.page .input-lbl.mb-15 {
  margin-bottom: 15px;
}
.page .input-lbl.mb-20 {
  margin-bottom: 20px;
}
.page .input-lbl.mb-25 {
  margin-bottom: 25px;
}
.page .input-lbl.mb-30 {
  margin-bottom: 30px;
}
.page .recap-grid {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px 25px;
  justify-content: center;
}
.page .recap-grid .input-lbl {
  grid-column: 1/3;
  margin-bottom: 8px;
}
.page .recap-grid .output-lbl {
  color: var(--app-mid-light);
  font-size: 17px;
  font-weight: 500;
}
.page .recap-grid .output-val {
  color: var(--app-mid-dark);
  font-size: 17px;
  font-weight: 500;
}
.page .recap-grid.mw-75p {
  margin: 0 auto;
  max-width: 75%;
}
.page .recap-grid.pt-0 {
  padding-top: 0px;
}
.page .recap-grid.pt0 {
  padding-top: 0px;
}
.page .recap-grid-type2 {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px 25px;
}
.page .recap-grid-type2 .hr {
  margin: 5px 0;
  grid-column: 1/3;
  height: 1px;
  background-color: var(--app-mid-lighter-2);
}
.page .recap-grid-type2 .input-lbl {
  margin-bottom: 20px;
  grid-column: 1/3;
  font-size: 16px;
}
.page .recap-grid-type2 .output-lbl {
  color: var(--app-mid-dark);
  font-size: 15px;
  font-weight: 500;
}
.page .recap-grid-type2 .output-val {
  justify-self: flex-end;
  color: var(--app-mid-light);
  font-size: 15px;
  font-weight: 500;
}
.page .recap-grid-type2 .rg-btn {
  margin: 0;
}
.page .recap-grid-type2 .rg-btn.rg-btn--confirm {
  margin-top: 30px;
  grid-column: 1/3;
  justify-self: center;
  --padding-start: 25px;
  --padding-end: 25px;
  font-weight: 600;
}
.page .searchbar {
  max-width: 350px;
}
.page .searchbar.mxv-400 {
  max-width: 400px;
}
.page .searchbar.mxv400 {
  max-width: 400px;
}
.page .select-item {
  display: flex;
  align-items: center;
}
.page .select-item .sp-lbl {
  margin-right: 20px;
  color: var(--app-mid-dark);
  font-weight: 500;
}
.page .select-item .sp-input.mxw-150 {
  max-width: 150px;
}
.page .select-item .sp-btn {
  margin: 0;
  margin-left: 12px;
  --border-radius: 50%;
  --padding-top: 6px;
  --padding-bottom: 6px;
  --padding-start: 6px;
  --padding-end: 6px;
  height: auto;
}
.page .select-item .sp-btn .btn-icon {
  font-size: 20px;
}
.page .template_emails-push {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, auto));
  gap: 25px 40px;
}
.page .template_emails-push .input-email {
  display: flex;
  align-items: center;
}
.page .template_emails-push .input-email .input-field {
  margin-right: 12px;
}
.page .template_emails-push .input-email .btn-add {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 8px;
  --padding-end: 8px;
  height: auto;
  font-size: 9px;
}
.page .template_emails-push .emails {
  padding-top: 10px;
}
.page .template_emails-push .emails .email {
  display: flex;
  align-items: center;
}
.page .template_emails-push .emails .email .text {
  margin-top: -1px;
  margin-right: 15px;
  color: var(--app-mid-dark);
  font-size: 17px;
  line-height: 20px;
  font-weight: 500;
  max-height: calc(2 * 20px);
  overflow-y: hidden;
}
.page .template_emails-push .emails .email .btn-close {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
  height: auto;
}
.page .template_emails-push .push-list {
  margin: -8px -5px;
  padding-top: 5px;
}
.page .template_emails-push .push-list .select-all {
  margin-bottom: 7px;
}
.page .template_emails-push.mt-25 {
  margin-top: 25px;
}
.page.as-centered-column {
  margin: 0 auto;
  max-width: 800px;
}

.pg-footer {
  background-color: var(--app-base);
}
.pg-footer ion-toolbar {
  --min-height: 0;
}

.row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, auto));
  gap: 25px 40px;
}
.row .col-title {
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 500;
}
.row .col-title ion-icon {
  margin-right: 10px;
}
.row .input-lbl {
  margin-bottom: 5px;
  font-size: 14px;
}
.row .input-lbl.text-muted {
  color: var(--app-mid-light);
}
.row .field-input {
  max-width: calc(400px * .75);
  margin-bottom: 20px;
}
.row .field-input .fi-input {
  font-size: 14px;
}
.row .field-input .fi-input.border-danger {
  border-color: var(--app-danger);
}
.row .field-input.field-input--select {
  position: relative;
  cursor: pointer;
}
.row .field-input.field-input--select .fi-input {
  pointer-events: none;
  --padding-end: 43px;
}
.row .field-input.field-input--select .sel-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}
.row .field-input .input-error {
  position: absolute;
  color: var(--app-danger);
  padding: 2px;
}

.page .input-field-wrap {
  display: inline;
  margin-bottom: 20px;
}

.no_flex {
  display: unset;
}
.no_flex ion-button {
  float: right;
}

.img-container {
  text-align: center;
  margin: 20px 0 40px 0;
}
.img-container img {
  height: 50px;
}

.alert-panel {
  padding: 7px 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.alert-panel .panel-icon {
  margin-right: 20px;
  font-size: 24px;
}
.alert-panel .panel-infos {
  flex: 1;
}
.alert-panel .panel-infos .pi-row--lbl {
  color: var(--app-mid-dark);
}
.alert-panel .panel-infos .pi-row:not(:last-child) {
  margin-bottom: 5px;
}

.more {
  color: var(--app-mid-dark);
  margin-top: 40px;
}
.more a {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/theme/mobile/desktop.scss","webpack://./src/app/pages/mobile/common/payment-problems/payment-problems.page.scss","webpack://./src/theme/mobile/_mixin.scss","webpack://./src/theme/mobile/modal.scss"],"names":[],"mappings":"AA2IA;EACE;;;;;;;;;;GAAA;EAYA,0CArJc;EAuJd,oBAAA;EACA,kBAvJa;EAyJb,UAAA;EAEA,kBAAA;AC9IF;;ADkKA;EAYE,0CA5Lc;EA6Ld,kBAAA;EAIA,oBAAA;EACA,kBAAA;AC7KF;;ADgLA;EAIE,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AChLF;;ADsLA;EACE,8CAnNc;EAoNf,kBAAA;EAEA,aAAA;EACA,8BAAA;ACpLD;ADsLC;EACC,SAAA;EACE,gBAAA;ACpLJ;ADwLI;EACE,gBAAA;ACtLN;AD0LC;EACC,eAAA;ACxLF;;AD4LA;EACE,kBAAA;EACA,wCAAA;ACzLF;AD4LI;EACE,mBAAA;AC1LN;AD4LM;EACE,gBAAA;AC1LR;AD+LE;EACE,kBAAA;AC7LJ;;ADoMA;EACE,qBAAA;EAEA,sBAAA;AClMF;;ADoOA;EACE,kBAAA;ACjOF;ADmOE;EACE,gBAAA;ACjOJ;ADqOE;EAwBE;;IAAA;ACxPJ;ADkOI;EACE,uBAAA;AChON;ADoOI;EACE,yBAAA;AClON;ADqOI;EACE,0BAAA;ACnON;ADuOI;EACE,sBAAA;ACrON;ADwOI;EACE,6BAAA;ACtON;AD6OI;EACE,6BAAA;AC3ON;AD8OI;EACE,6BAAA;AC5ON;ADgPI;EACE,2BAAA;AC9ON;ADiPI;EACE,6BAAA;AC/ON;ADkPI;EACE,+BAAA;AChPN;;AChCA;;;;;;;CAAA;AC5DA;EACC,YAAA;EAEA,aAAA;EACA,sBAAA;AFsGD;AEpGC;EACC,OAAA;EACA,gBAAA;EAEA,aAAA;EACE,uBAAA;AFqGJ;AEnGE;EACC,cAAA;EACA,WAAA;EACA,gBHdgB;ACmHnB;;AE9FA;EACC,uBHFQ;EGGR,iBHRW;ACyGZ;AE3FC;EACC,aAAA;EAEA,uBAAA;AF4FF;AE1FE;EACC,SAAA;EACA,gBAAA;AF4FH;AE1FG;EACC,gBAAA;AF4FJ;AExFI;EACC,kBAAA;AF0FL;AEpFE;EACC,gBAAA;AFsFH;AEjFC;EACC,iBAAA;AFmFF;AEhFE;EACC,gBAAA;AFkFH;AE7EC;EACC,0BAAA;AF+EF;AE7EE;EAEC,gBAAA;AF8EH;AE5EG;EACC,yBAAA;AF8EJ;AEzEE;EACC,gBAAA;AF2EH;AExEE;EACC,mBAAA;AF0EH;AEvEE;EACC,iBAAA;AFyEH;AEnEC;EACC,aAAA;EACA,uBAAA;AFqEF;AElEE;EACC,OAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;AFmEH;AEjEG;EACC,kBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;AFiEJ;AE7DG;EACC,OAAA;EACA,0CHvIY;ACsMhB;AE7DI;EACC,sBAAA;AF+DL;AE3DG;EACC,mBAAA;AF6DJ;AExDE;EACC,gBAAA;AF0DH;AExDE;EACC,gBAAA;AF0DH;AErDC;EACC,aAAA;EACA,mBAAA;AFuDF;AExCE;EAEC,gBAAA;AFyCH;AElDI;EACC,iBAAA;AFoDL;AErDI;EACC,iBAAA;AFuDL;AClNG;EAEE,gBAAA;ADmNL;ACrNG;EAEE,gBAAA;ADsNL;ACxNG;EAEE,gBAAA;ADyNL;AC3NG;EAEE,gBAAA;AD4NL;AC9NG;EAEE,gBAAA;AD+NL;ACjOG;EAEE,gBAAA;ADkOL;AExDG;EAEC,eAAA;AFyDJ;AEpCG;EACC,eAAA;AFsCJ;AEnCG;EAEC,eAAA;AFoCJ;AEjCG;EACC,gBAAA;AFmCJ;AEjCG;EACC,gBAAA;AFmCJ;AEhCG;EACC,SAAA;AFkCJ;AE7BE;EACC,iBAAA;EAGA,6BAAA;EAEA,eAAA;AF4BH;AE1BG;EACC,iBAAA;AF4BJ;AE1BG;EACC,iBAAA;AF4BJ;AEvBE;EACC,iBAAA;EAEA,oCAAA;EAEA,eAAA;EACA,gBAAA;AFuBH;AEnBE;EACC,sBAAA;EACA,uBAAA;AFqBH;AEnBG;EAGC,0BAAA;EACA,eAAA;EACA,gBAAA;AFmBJ;AEjBI;EACC,gBAAA;AFmBL;AEjBI;EACC,kBAAA;AFmBL;AEjBI;EACC,mBAAA;AFmBL;AEjBI;EACC,mBAAA;AFmBL;AEjBI;EACC,mBAAA;AFmBL;AEjBI;EACC,mBAAA;AFmBL;AEjBI;EACC,mBAAA;AFmBL;AEbE;EACC,aAAA;EACA,6DAAA;EACA,SAAA;AFeH;AEXE;EACC,mBApQG;AFiRN;AERE;EACC,gBAAA;AFUH;AERE;EACC,kBAAA;AFUH;AERE;EACC,mBAAA;AFUH;AERE;EACC,mBAAA;AFUH;AERE;EACC,mBAAA;AFUH;AERE;EACC,mBAAA;AFUH;AERE;EACC,mBAAA;AFUH;AEPE;EACC,gBAAA;AFSH;AEDC;EACC,aAAA;EACA,eAAA;AFGF;AEAE;EACC,oBAAA;AFEH;AECI;EACC,iBAAA;AFCL;AEME;EACC,aAAA;EACA,6DAAA;EACA,cAAA;AFJH;AEiCE;EACC,qBAAA;AF/BH;AEmCE;EACC,mBA/VG;AF8TN;AEuCC;EAGC,mBAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;AFxCF;AE0CE;EACC,0BAAA;AFxCH;AE2CE;EACC,eAAA;AFzCH;AE2CE;EACC,eAAA;AFzCH;AE2CE;EACC,eAAA;AFzCH;AE2CE;EACC,eAAA;AFzCH;AE2CE;EACC,eAAA;AFzCH;AE2CE;EACC,eAAA;AFzCH;AE4CE;EACC,gBAAA;AF1CH;AE4CE;EACC,kBAAA;AF1CH;AE4CE;EACC,mBAAA;AF1CH;AE4CE;EACC,mBAAA;AF1CH;AE4CE;EACC,mBAAA;AF1CH;AE4CE;EACC,mBAAA;AF1CH;AE4CE;EACC,mBAAA;AF1CH;AE+CC;EACC,iBAAA;EAEA,aAAA;EACA,sCAAA;EACA,cAAA;EAGA,uBAAA;AFhDF;AEyDE;EACC,gBAAA;EACA,kBAAA;AFvDH;AE8DE;EACC,2BAAA;EACA,eALI;EAMJ,gBALI;AFvDP;AE+DE;EACC,0BAAA;EACA,eAXI;EAYJ,gBAXI;AFlDP;AEmEE;EACC,cAAA;EACA,cAAA;AFjEH;ACnaG;EAEE,gBAAA;ADoaL;ACtaG;EAEE,gBAAA;ADuaL;AEkEC;EACC,iBAAA;EAEA,aAAA;EACA,sCAAA;EACA,cAAA;AFjEF;AE6EE;EACC,aAAA;EACA,gBAAA;EACA,WAAA;EACA,0CAAA;AF3EH;AE+EE;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;AF7EH;AEoFE;EACC,0BAAA;EACA,eALI;EAMJ,gBALI;AF7EP;AEqFE;EACC,sBAAA;EAEA,2BAAA;EACA,eAbI;EAcJ,gBAbI;AFvEP;AE0FE;EACC,SAAA;AFxFH;AE0FG;EACC,gBAAA;EACA,gBAAA;EACA,oBAAA;EAGA,qBAAA;EACA,mBAAA;EAEA,gBAAA;AF3FJ;AEuGC;EAEC,gBAAA;AFtGF;ACndG;EAEE,gBAAA;ADodL;ACtdG;EAEE,gBAAA;ADudL;AEsGC;EACC,aAAA;EACA,mBAAA;AFpGF;AEsGE;EACC,kBAAA;EAEA,0BAAA;EACA,gBAAA;AFrGH;AE6GI;EACC,gBAAA;AF3GL;AEkHE;EACC,SAAA;EACA,iBAAA;EAEA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;AFpHH;AEsHG;EACC,eAAA;AFpHJ;AE6HC;EACC,aAAA;EACA,4DAAA;EACA,cAAA;AF3HF;AEgIE;EACC,aAAA;EACA,mBAAA;AF9HH;AEgIG;EAEC,kBAAA;AF/HJ;AEkIG;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;EAEA,cAAA;AFpIJ;AE2IE;EACC,iBAAA;AFzIH;AE2IG;EACC,aAAA;EACA,mBAAA;AFzIJ;AE2II;EACC,gBAAA;EACA,kBAAA;EAEA,0BAAA;EAGA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,kBAAA;AF7IL;AEmJI;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;AFpJL;AE8JE;EACC,iBAAA;EACA,gBAAA;AF5JH;AE8JG;EACC,kBAAA;AF5JJ;AEgKE;EACC,gBAAA;AF9JH;AEoKC;EACC,cAAA;EACA,gBH/sBiB;AC6iBnB;;AE0KA;EAEC,iCAAA;AFxKD;AE0KE;EACE,eAAA;AFxKJ;;AAhkBA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;AAmkBF;AAjkBE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAmkBJ;AAlkBI;EACE,kBAAA;AAokBN;AAhkBE;EACE,kBAAA;EACA,eAAA;AAkkBJ;AAhkBI;EACE,2BAAA;AAkkBN;AA9jBE;EACE,4BA3Ba;EA4Bb,mBAAA;AAgkBJ;AA9jBI;EAEE,eA/BD;AA8lBL;AA7jBM;EACE,+BAAA;AA+jBR;AA3jBI;EACE,kBAAA;EACA,eAAA;AA6jBN;AA3jBM;EACE,oBAAA;EACA,mBAAA;AA6jBR;AA1jBM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,2BAAA;AA2jBR;AAvjBI;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;AAyjBN;;AAjjBE;EACE,eAAA;EACA,mBAAA;AAojBJ;;AAhjBA;EACE,cAAA;AAmjBF;AAljBE;EACE,YAAA;AAojBJ;;AAhjBA;EACE,kBAAA;EACA,qBAAA;AAmjBF;AAljBE;EACE,YAAA;AAojBJ;;AAhjBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAmjBF;AAjjBE;EACE,kBAAA;EACA,eAAA;AAmjBJ;AAhjBE;EACE,OAAA;AAkjBJ;AA9iBM;EACE,0BAAA;AAgjBR;AA7iBM;EACE,kBAAA;AA+iBR;;AAxiBA;EACE,0BAAA;EACA,gBAAA;AA2iBF;AA1iBE;EACE,eAAA;AA4iBJ","sourcesContent":["\n\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n$page_maxW-mobile: 800px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  --px: 7px;\n  $px: var(--px);\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n  @media (min-width: 360px) {\n    --px: 10px;\n  }\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n  --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","@use \"../../../../../theme/mobile/modal\" as *;\n\n\n$maxWidth: 400px;\n$field_maxWidth: calc(#{$maxWidth} * .75);\n$fz: 14px;\n\n.row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, auto));\n  gap: 25px 40px;\n\n  .col-title{\n    font-size: 16px;\n    margin-bottom: 15px;\n    font-weight: 500;\n    ion-icon{\n      margin-right: 10px;\n    }\n  }\n\n  .input-lbl{\n    margin-bottom: 5px;\n    font-size: 14px;\n\n    &.text-muted{\n      color: var(--app-mid-light);\n    }\n  }\n\n  .field-input {\n    max-width: $field_maxWidth;\n    margin-bottom: 20px;\n\n    .fi-input {\n      @extend %input-lg;\n      font-size: $fz;\n\n      &.border-danger{\n        border-color: var(--app-danger);\n      }\n    }\n\n    &.field-input--select {\n      position: relative;\n      cursor: pointer;\n\n      .fi-input {\n        pointer-events: none;\n        --padding-end: 43px;\n      }\n\n      .sel-icon {\n        position: absolute;\n        top: 50%;\n        right: 15px;\n\n        transform: translateY(-50%);\n      }\n    }\n\n    .input-error{\n      position: absolute;\n      color: var(--app-danger);\n      padding: 2px;\n    }\n\n  }\n\n}\n\n.page{\n  .input-field-wrap{\n    display: inline;\n    margin-bottom: 20px;\n  }\n}\n\n.no_flex{\n  display: unset;\n  ion-button{\n    float: right;\n  }\n}\n\n.img-container{\n  text-align: center;\n  margin: 20px 0 40px 0;\n  img{\n    height: 50px;\n  }\n}\n\n.alert-panel {\n  padding: 7px 10px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n\n  .panel-icon {\n    margin-right: 20px;\n    font-size: 24px;\n  }\n\n  .panel-infos {\n    flex: 1;\n    @extend %longWord;\n\n    .pi-row {\n      &--lbl {\n        color: var(--app-mid-dark);\n      }\n\n      &:not(:last-child) {\n        margin-bottom: 5px;\n      }\n    }\n\n  }\n}\n\n.more{\n  color: var(--app-mid-dark);\n  margin-top: 40px;\n  a{\n    cursor: pointer;\n  }\n}\n","\n// * see also: (in balinApp_mobile) \n// item.component.scss\n\n\n\n@mixin modifier($classes, $props, $vals) {\n\t// * params eg.\n\t// $classes: py- py;\n\t// $prop: padding-top padding-bottom; \n\t// $vals: 10 50;\n\t\n\t\n\t@each $class in $classes {\n\t\t@each $val in $vals {\n\t\t\t\n\t\t\t&.#{$class}#{$val} {\n\t\t\t\t@each $prop in $props {\n\t\t\t\t\t#{$prop}: $val + px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n\t\n\t\n\t// * will generate:\n\t// #region\n\t\n\t// &.py-10 {\n\t// \tpadding-top: 10px;\n\t// \tpadding-bottom: 10px;\n\t// }\n\t// &.py-50 {\n\t// \tpadding-top: 50px;\n\t// \tpadding-bottom: 50px;\n\t// }\n\t\n\t// &.py10 {\n\t// \tpadding-top: 10px;\n\t// \tpadding-bottom: 10px;\n\t// }\n\t// &.py50 {\n\t// \tpadding-top: 50px;\n\t// \tpadding-bottom: 50px;\n\t// }\n\t\n\t\n\t// * in HTML\n\t// class=\"elem py-50 py-10\"\n\t// .elem's padding-top, padding-bottom == 50px\n\t\n\t// class=\"elem py-50 py10\"\n\t// .elem's padding-top, padding-bottom == 10px\n\t\n\t// #endregion\n\t\n\t\n\t// * usage\n\t// #region\n\t\n\t// @include modifier(py- py, padding-top padding-bottom, 10 50);\n\t\n\t// or\n\t\n\t// @include modifier(\n\t// \tpy- py, \n\t// \tpadding-top padding-bottom, \n\t// \t10 50\n\t// );\n\t\n\t// #endregion\n\t\n}\n\n\n\n/* \naggiungere mixin per:\n- elementi lista con + di una riga\n\nprove da fare:\n- dove uso @media, sia dentro che fuori puntare alle classi usando\n  le variabili css ($)\n*/\n\n\n\n\n\n\n\n\n\n\n\n\n","\n\n@use \"desktop\" as *;\n@forward \"desktop\";\n\n@use \"_mixin\" as mxn;\n\n\n\n\n.pg-header {\n\t@extend %modalHeader;\n}\n\n\n\n// added 4 mobile\n.page-wrapper {\n\theight: 100%;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t.page-wrap-scrollable {\n\t\tflex: 1;\n\t\toverflow-y: auto;\n\n\t\tdisplay: flex;\n    align-items: flex-start;\n\n\t\t.page {\n\t\t\tmargin: 0 auto;\n\t\t\twidth: 100%;\n\t\t\tmax-width: $page_maxW-mobile;\n\t\t}\n\t}\n\n}\n\n\n.page {\n\tpadding: $page_p;\n\tpadding-top: $page_pt30;\n\n\t$mb: 20px;\n\n\n\n\t.btnbar {\n\t\tdisplay: flex;\n\t\t// align-items: center;\n\t\tjustify-content: center;\n\n\t\t.el-btn {\n\t\t\tmargin: 0;\n\t\t\tfont-weight: 600;\n\n\t\t\t&.mw-180 {\n\t\t\t\tmin-width: 180px;\n\t\t\t}\n\n\t\t\t&:not(:last-child) {\n\t\t\t\t&.mr-25 {\n\t\t\t\t\tmargin-right: 25px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t\t&.mt-40 {\n\t\t\tmargin-top: 40px;\n\t\t}\n\t}\n\n\n\t.checkboxes {\n\t\tpadding-top: 15px;\n\t\t// max-width: 350px;\n\n\t\t&.pt-5 {\n\t\t\tpadding-top: 5px;\n\t\t}\n\t}\n\n\n\t.description {\n\t\tcolor: var(--app-mid-dark);\n\n\t\t.b {\n\t\t\t// font-weight: 500;\n\t\t\tfont-weight: 600;\n\n\t\t\t&.uppercase {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\n\n\t\t&.lh-13 {\n\t\t\tline-height: 1.3;\n\t\t}\n\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\n\t\t&.pt-10 {\n\t\t\tpadding-top: 10px;\n\t\t}\n\n\t}\n\n\n\t.images-cart {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\t// align-items: center;\n\n\t\t.img-panel {\n\t\t\tflex: 1;\n\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\n\t\t\t.ip-num {\n\t\t\t\tmargin-bottom: 5px;\n\n\t\t\t\tcolor: var(--app-main);\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\n\t\t\t.ip-img-wrap {\n\t\t\t\tflex: 1;\n\t\t\t\tborder: $borderDivider;\n\n\t\t\t\t.ip-img {\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tpadding-right: 30px;\n\t\t\t}\n\t\t}\n\n\n\t\t&.mt-20 {\n\t\t\tmargin-top: 20px;\n\t\t}\n\t\t&.mt-25 {\n\t\t\tmargin-top: 25px;\n\t\t}\n\t}\n\n\n\t.input-field-wrap {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\n\t\t@mixin margin-lefts {\n\t\t\t$sizes: 15 20;\n\n\t\t\t@each $size in $sizes {\n\t\t\t\t// &.fz#{$size},\n\t\t\t\t&.ml-#{$size} {\n\t\t\t\t\tmargin-left: $size + px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\n\t\t.input-field {\n\t\t\t@extend %input;\n\t\t\tmax-width: 300px;\n\n\t\t\t@include margin-lefts;\n\t\t\t@include mxn.modifier(\n\t\t\t\tmxv- mxv,\n\t\t\t\tmax-width,\n\t\t\t\t250 350 400\n\t\t\t);\n\n\t\t\t&.mxv-100p,\n\t\t\t&.mxv100p {\n\t\t\t\tmax-width: 100%\n\t\t\t}\n\n\t\t\t// &.readonly {\n\t\t\t// \tborder: 0;\n\t\t\t// }\n\t\t}\n\n\t\t.input-field-lg {\n\t\t\t@extend %input-lg;\n\n\t\t\t// &.input-field-lg--sm {\n\t\t\t// \t// desktop.%input\n\t\t\t// \t--padding-top: 8px;\n\t\t\t// \t--padding-bottom: 8px;\n\t\t\t// \t--padding-start: 8px;\n\t\t\t// \t--padding-end: 8px;\n\n\t\t\t// \tfont-size: 14px;\n\t\t\t// }\n\n\t\t\t&.fz-15 {\n\t\t\t\tfont-size: 15px;\n\t\t\t}\n\n\t\t\t&.mxv-100p,\n\t\t\t&.mxv100p {\n\t\t\t\tmax-width: 100%\n\t\t\t}\n\n\t\t\t&.mxw-300 {\n\t\t\t\tmax-width: 300px;\n\t\t\t}\n\t\t\t&.mxw-350 {\n\t\t\t\tmax-width: 350px;\n\t\t\t}\n\n\t\t\t&.readonly {\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t}\n\n\n\t\t.input-help {\n\t\t\tmargin-left: 12px;\n\n\t\t\t// color: rgba(var(--app-main-softer-rgb), .7);\n\t\t\tcolor: var(--app-main-softer);\n\n\t\t\tfont-size: 22px;\n\n\t\t\t&.ml-15 {\n\t\t\t\tmargin-left: 15px;\n\t\t\t}\n\t\t\t&.ml-20 {\n\t\t\t\tmargin-left: 20px;\n\t\t\t}\n\t\t}\n\n\n\t\t.input-unit {\n\t\t\tmargin-left: 12px;\n\n\t\t\tcolor: rgba(var(--app-mid-rgb), .7);\n\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t}\n\n\n\t\t&.w-stacked-lbl {\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\n\t\t\t.input-field-lbl {\n\t\t\t\t@extend %longWord;\n\n\t\t\t\tcolor: var(--app-mid-dark);\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\t&.mb-0 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t&.mb-5 {\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\t&.mb-10 {\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t}\n\t\t\t\t&.mb-15 {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t\t&.mb-20 {\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t\t&.mb-25 {\n\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t}\n\t\t\t\t&.mb-30 {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t\t&.dg-v1 {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(auto-fit, minmax(200px, 250px));\n\t\t\tgap: 15px;\n\t\t}\n\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: $mb;\n\t\t}\n\n\n\t\t// ? can this be done better w/ Sass syntax?\n\t\t&.mb-0 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t&.mb-5 {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t&.mb-10 {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t\t&.mb-15 {\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t&.mb-25 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t\t&.mb-30 {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\n\t\t&.mxw-350 {\n\t\t\tmax-width: 350px;\n\t\t}\n\n\t}\n\n\n\t// copied from modal_alarm.scss\n\t// renamed from .input-fields to avoid name collision\n\t.input-fields-vModal_alarm {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\n\t\t&.input-fields--check {\n\t\t\tmargin: -8px -10px 0;\n\n\t\t\t.input-field {\n\t\t\t\t&.special {\n\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t&.input-fields--text {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(auto, 250px));\n\t\t\tgap: 10px 30px;\n\n\t\t\t.input-field {\n\t\t\t\t// &.input-field--text {\n\n\t\t\t\t// --background\tBackground of the input\n\t\t\t\t// --color\tColor of the input text\n\t\t\t\t// --padding-bottom\tBottom padding of the input\n\t\t\t\t// --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n\t\t\t\t// --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n\t\t\t\t// --padding-top\tTop padding of the input\n\t\t\t\t// --placeholder-color\tColor of the input placeholder text\n\t\t\t\t// --placeholder-font-style\tFont style of the input placeholder text\n\t\t\t\t// --placeholder-font-weight\tFont weight of the input placeholder text\n\t\t\t\t// --placeholder-opacity\tOpacity of the input placeholder text\n\n\t\t\t\t@extend %input;\n\n\n\t\t\t\t// }\n\n\t\t\t\t// &.input-field--poi {\n\t\t\t\t// \tcursor: pointer;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t}\n\n\n\t\t&.input-fields--toggle {\n\t\t\tmargin: -10px -#{$page_px} 0;\n\t\t}\n\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: $mb;\n\t\t}\n\n\t}\n\n\n\t.input-lbl {\n\t\t@extend %longWord;\n\n\t\tmargin-bottom: 15px;\n\n\t\tcolor: var(--app-mid);\n\t\tfont-size: 18px;\n\t\tfont-weight: 500;\n\n\t\t&.input-lbl--mid-dark {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t}\n\n\t\t&.fz-14 {\n\t\t\tfont-size: 14px;\n\t\t}\n\t\t&.fz-15 {\n\t\t\tfont-size: 15px;\n\t\t}\n\t\t&.fz-16 {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\t&.fz-17 {\n\t\t\tfont-size: 17px;\n\t\t}\n\t\t&.fz-19 {\n\t\t\tfont-size: 19px;\n\t\t}\n\t\t&.fz-20 {\n\t\t\tfont-size: 20px;\n\t\t}\n\n\t\t&.mb-0 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t&.mb-5 {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t&.mb-10 {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t\t&.mb-15 {\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t&.mb-25 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t\t&.mb-30 {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\n\n\t.recap-grid {\n\t\tpadding-top: 30px;\n\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, auto);\n\t\tgap: 12px 25px;\n\n\t\t// spacing of all elems relative to the container\n\t\tjustify-content: center;\n\t\t// align-content: flex-start;\n\t\t// min-height: 100%;\n\n\t\t// handle spacing inside elems\n    // align-items: center;\n\t\t// justify-items: center;\n\n\n\t\t.input-lbl {\n\t\t\tgrid-column: 1/3;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\n\t\t$fz: 17px;\n\t\t$fw: 500;\n\n\t\t.output-lbl {\n\t\t\tcolor: var(--app-mid-light);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\t\t}\n\n\t\t.output-val {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t\t@extend %longWord;\n\t\t}\n\n\n\t\t&.mw-75p {\n\t\t\tmargin: 0 auto;\n\t\t\tmax-width: 75%;\n\t\t}\n\n\t\t@include mxn.modifier(pt- pt, padding-top, 0);\n\n\t}\n\n\t.recap-grid-type2 {\n\t\tpadding-top: 30px;\n\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, auto);\n\t\tgap: 12px 25px;\n\n\t\t// spacing of all elems relative to the container\n\t\t// justify-content: center;\n\t\t// align-content: flex-start;\n\t\t// min-height: 100%;\n\n\t\t// handle spacing inside elems\n    // align-items: center;\n\t\t// justify-items: space-between;\n\n\n\t\t.hr {\n\t\t\tmargin: 5px 0;\n\t\t\tgrid-column: 1/3;\n\t\t\theight: 1px;\n\t\t\tbackground-color: var(--app-mid-lighter-2);\n\t\t}\n\n\n\t\t.input-lbl {\n\t\t\tmargin-bottom: 20px;\n\t\t\tgrid-column: 1/3;\n\t\t\tfont-size: 16px;\n\t\t}\n\n\t\t// ero qui\n\t\t$fz: 15px;\n\t\t$fw: 500;\n\n\t\t.output-lbl {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\t\t}\n\n\t\t.output-val {\n\t\t\tjustify-self: flex-end;\n\n\t\t\tcolor: var(--app-mid-light);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t\t@extend %longWord;\n\t\t}\n\n\n\t\t.rg-btn {\n\t\t\tmargin: 0;\n\n\t\t\t&.rg-btn--confirm {\n\t\t\t\tmargin-top: 30px;\n\t\t\t\tgrid-column: 1/3;\n\t\t\t\tjustify-self: center;\n\n\t\t\t\t$p: 25px;\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\n\t\t// &.mw-75p {\n\t\t// \tmargin: 0 auto;\n\t\t// \tmax-width: 75%;\n\t\t// }\n\t}\n\n\n\t.searchbar {\n\t\t@extend %search;\n\t\tmax-width: 350px;\n\n\t\t@include mxn.modifier(mxv- mxv, max-width, 400);\n\t}\n\n\n\t.select-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.sp-lbl {\n\t\t\tmargin-right: 20px;\n\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-weight: 500;\n\t\t}\n\n\n\t\t.sp-input {\n\t\t\t// width: ;\n\n\t\t\t&.mxw- {\n\t\t\t\t&150 {\n\t\t\t\t\tmax-width: 150px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t.sp-btn {\n\t\t\tmargin: 0;\n\t\t\tmargin-left: 12px;\n\n\t\t\t--border-radius: 50%;\n\n\t\t\t$p: 6px;\n\t\t\t--padding-top: #{$p};\n\t\t\t--padding-bottom: #{$p};\n\t\t\t--padding-start: #{$p};\n\t\t\t--padding-end: #{$p};\n\n\t\t\theight: auto;\n\n\t\t\t.btn-icon {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\n\t}\n\n\n\t// copied from modal_alarm.scss\n\t// (look for: &.page-3)\n\t.template_emails-push {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(auto-fit, minmax(300px, auto));\n\t\tgap: 25px 40px;\n\n\t\t// .col {}\n\n\n\t\t.input-email {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.input-field {\n\t\t\t\t@extend %input;\n\t\t\t\tmargin-right: 12px;\n\t\t\t}\n\n\t\t\t.btn-add {\n\t\t\t\tmargin: 0;\n\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t$p: 8px;\n\t\t\t\t--padding-top: #{$p};\n\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\theight: auto;\n\n\t\t\t\tfont-size: 9px;\n\n\t\t\t\t// .btn-icon {}\n\t\t\t}\n\t\t}\n\n\n\t\t.emails {\n\t\t\tpadding-top: 10px;\n\n\t\t\t.email {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.text {\n\t\t\t\t\tmargin-top: -1px;\n\t\t\t\t\tmargin-right: 15px;\n\n\t\t\t\t\tcolor: var(--app-mid-dark);\n\n\t\t\t\t\t$lh: 20px;\n\t\t\t\t\tfont-size: 17px;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\tmax-height: calc(2 * #{$lh});\n\t\t\t\t\toverflow-y: hidden;\n\n\t\t\t\t\t// @extend %oneLiner;\n\t\t\t\t\t@extend %longWord;\n\t\t\t\t}\n\n\t\t\t\t.btn-close {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t\t$p: 5px;\n\t\t\t\t\t--padding-top: #{$p};\n\t\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t\theight: auto;\n\n\t\t\t\t\t// .btn-icon {}\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t}\n\n\n\t\t.push-list {\n\t\t\tmargin: -8px -5px;\n\t\t\tpadding-top: 5px;\n\n\t\t\t.select-all {\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t}\n\t\t}\n\n\t\t&.mt-25 {\n\t\t\tmargin-top: 25px;\n\t\t}\n\t}\n\n\n\n\t&.as-centered-column {\n\t\tmargin: 0 auto;\n\t\tmax-width: $page_maxW-mobile;\n\t}\n\n\n}\n\n\n\n.pg-footer {\n\t@extend %modalFooter;\n\tbackground-color: var(--app-base);\n\n  ion-toolbar{\n    --min-height: 0;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
